import {useCallback} from 'react';
import {Platform} from 'react-native';
import {api} from '../../../../../services/api';
import {getPersistentDeviceId} from '../../../../../utils/deviceId';
import {
  getModel,
  getMaxMemory,
  getUsedMemory,
  getApiLevel,
  getSystemVersion,
  getSystemName,
  getDevice,
  getHardware,
  getVersion,
} from 'react-native-device-info';

type CreditCardPaymentPayload = {
  region?: string;
  value?: number;
  number?: string;
  codigoParceiro?: string;
  expiry?: string;
  versao?: string;
  baratinhas?: boolean;
  cvc?: string;
  cpf?: string;
  placa?: string;
  codigo?: string;
  sessionId?: string;
  parcelas?: string;
  pedidos?: unknown;
  incentiveUserId?: string | null;
  clientId?: string | null;
  posto_id: string;
  deviceModel?: string;
  deviceInfos?: string;
  [key: string]: any;
};

type PixPaymentPayload = {
  region?: string;
  versao?: string;
  codigoParceiro?: string;
  value?: number;
  placa?: string;
  baratinhas?: boolean;
  codigo?: string;
  pedidos?: unknown;
  banco?: string;
  incentiveUserId?: string | null;
  clientId?: string | null;
  posto_id?: string;
  [key: string]: any;
};

export function usePaymentGateway() {
  const getDeviceInfo = useCallback(async () => {
    return {
      model: getModel(),
      maxMemory: await getMaxMemory(),
      usedMemory: await getUsedMemory(),
      apiLevel: await getApiLevel(),
      systemVersion: getSystemVersion(),
      systemName: getSystemName(),
      device: getDevice(),
      hardware: getHardware(),
      version: getVersion(),
      platform: Platform.OS,
    };
  }, []);

  const postCreditCardPayment = useCallback(
    async <T = any>(payload: CreditCardPaymentPayload): Promise<T> => {
      try {
        const deviceId = await getPersistentDeviceId();
        const deviceInfo = await getDeviceInfo();
        const deviceModelString = JSON.stringify(deviceInfo);

        const {data} = await api.post('/payments/creditcard', {
          ...payload,
          device_id: deviceId,
          deviceInfos: deviceModelString,
        });

        return data as T;
      } catch (error) {
        console.log('Error in postCreditCardPayment:', error);
        throw error;
      }
    },
    [getDeviceInfo],
  );

  const postPixPayment = useCallback(
    async <T = any>(payload: PixPaymentPayload): Promise<T> => {
      try {
        const deviceId = await getPersistentDeviceId();
        const deviceInfo = await getDeviceInfo();
        const deviceModelString = JSON.stringify(deviceInfo);

        const {data} = await api.post('/payments/pix', {
          ...payload,
          device_id: deviceId,
          deviceInfos: deviceModelString,
        });

        return data as T;
      } catch (error) {
        console.log('Error in postPixPayment:', error);
        throw error;
      }
    },
    [getDeviceInfo],
  );

  const verificaStatusPagamentoCartao = useCallback(
    (params: { compra_id?: string; ds_trans_id?: string }) =>
      api.get('/payments/status_pagamento_cartao', { params }),
    [],
  );

  return {
    postCreditCardPayment,
    postPixPayment,
    verificaStatusPagamentoCartao,
  };
}
